import { TableSchema } from '../metadata-schema';
import { instelling } from './instelling';
import { Vaardigheid } from '../enums/Vaardigheid';

export const bvn_basisvaardigheden_norm: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "bvn_basisvaardigheden_norm",
	"description": "Definitie voor sys tabel bvn_basisvaardigheden_norm uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.SysTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"abbrev": "bvn",
	"properties": {
		"bvn_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"bvn_fun_nm_niveau": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_fun_nr_leerjaar": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_nm_leerfase": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_nm_vaardigheid": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Vaardigheid
		},
		"bvn_nr_referentieniveau": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bvn_nr_frac_doel": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
